import React from 'react';
import Box from '@mui/material/Box';
import { GlobalUtilContext } from '../../contexts';
import CircularProgress from '@mui/material/CircularProgress';

function LoadingOverlay() {
  const { isLoading, isLoggedIn } = React.useContext(GlobalUtilContext);

  if (isLoading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100000,
          height: '100%',
          width: '100%',
          background: 'rgba(255, 255, 255, 0.78)',
          marginLeft: isLoggedIn ? '180px' : '0',
          paddingRight: isLoggedIn ? '180px' : '0'
        }}
      >
        <CircularProgress
          size={60}
          sx={{ color: '#00010E' }}
          thickness={6}
          variant="indeterminate"
        />
      </Box>
    );
  }

  return null;
}

export { LoadingOverlay };
